export default "__VITE_ASSET__BXZlfAza__"